module.exports = __webpack_public_path__ + "static/media/partner.30282a45.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/HowItWorks/assets/partner.png
// module id = 463
// module chunks = 0